import FilmanizeRadio from "../../shared/filmanize-radio";
import ScrollIntoView from "../../shared/scroll-into-view/scroll-into-view";

const FoundCostumes = (props) => {
    const { costumes } = props;

    const onChange = (value) => {

    };

    return (
        <ScrollIntoView
            className="blade-content wide"
            loading={false}>
            <div>
                <h2 className="menu-label">Found Costumes</h2>
                <table className="table is-striped is-hoverable is-fullwidth">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Costume Name</th>
                            <th>Characters</th>
                            <th>Background Characters</th>
                        </tr>
                    </thead>
                    <tbody>
                        {costumes.map((costume, index) => (
                            <tr>
                                <td><FilmanizeRadio checked={false} onChange={onChange} value={costume.id} /></td>
                                <td>{costume.name}</td>
                                <td>
                                    {costume.characters.map((character, index) => (
                                        <div key={index} className="character-item">
                                            <h4>{character}</h4>
                                        </div>
                                    ))}
                                </td>
                                <td>
                                    {costume.backgroundCharacters.map((character, index) => (
                                        <div key={index} className="character-item">
                                            <h4>{character}</h4>
                                        </div>
                                    ))}
                                </td>
                            </tr>))}
                    </tbody>
                </table>
                <div className="buttons mt-1">
                    <button className="button is-primary" onClick={() => props.onAddCostume()}>Add to scene</button>
                </div>

            </div>
        </ScrollIntoView>
    )
}

export default FoundCostumes;